import React from 'react'
import styled from 'styled-components'
import { media, style } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { fonts } from 'app/common/typography'
import { Arrow } from 'app/assets/icons'

type Props = {
    slideIndex: number,
    tilesSize: number,
    previous: any,
    next: any
}

const SliderNavigation = (props: Props) => {
    const { slideIndex, tilesSize, previous, next } = props
    return (
        <SliderNavigationContainer>
            <Button onClick={previous}>
                <Arrow />
            </Button>
            <Index>
                <Span color={colors.red}>{slideIndex + 1}</Span>
                <Span color={colors.lightGrey}>/</Span>
                <Span color={colors.text}>{tilesSize}</Span>
            </Index>
            <Button onClick={next}>
                <Arrow direction="right" />
            </Button>
        </SliderNavigationContainer>
    )
}

const border = `
    1px solid ${colors.lightGrey}
`

const SliderNavigationContainer = styled.div`
    font-family: ${fonts.flameRegular};
    height: 65px;
    margin: 30px 20px;
    border-top: ${border};
    border-bottom: ${border};
    ${style.flexBetween};

    ${media.medium`
        margin: 15px 0;
    `};

    ${media.large`
        margin: 30px 0;
    `};
`

const Index = styled.div`
    ${style.flexBetween};
    width: 20%;
`

const Span = styled.span`
    color: ${props => props.color};
`

const Button = styled.button`
    background: transparent;
    ${style.button};
`

export { SliderNavigation }
